import { render, staticRenderFns } from "./SiloSettings.vue?vue&type=template&id=163bef7a&scoped=true&"
import script from "./SiloSettings.vue?vue&type=script&lang=ts&"
export * from "./SiloSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163bef7a",
  null
  
)

export default component.exports